export const LOCAL = 'EVN_LOCAL';
export const TEST = 'EVN_TEST';
export const RELEASE = 'EVN_RELEASE';
